import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {Resource} from "../../api/resource";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {ManagerCachingStrategy, SearchType} from "../../basic-entity-back/basic-entity-interface/mapping-external";

@BasicEntity({
    name: 'Tipos de usuario',
    endpoint: 'user_groups',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'name',
    acceptsBulkIriSearch: true,
    type: 'UserGroup',
    managerCaching: ManagerCachingStrategy.PrecacheOnStart
})
export class UserGroup extends Resource {
    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id: number;

    @BasicProperty({
        name: 'Nombre',
        type: PropertyType.String()
    })
    private _name: string;

    @BasicProperty({
        name: 'Roles',
        type: PropertyType.String(),
        array: true
    })
    private _roles: string[];

    @BasicProperty({
        name: 'Email',
        type: PropertyType.Email(),
        sortable: true
    })
    private _email;

    @BasicProperty({
        name: 'Recibe mensajes',
        type: PropertyType.Boolean()
    })
    private _recibeMensajes: boolean = false;

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get roles(): string[] {
        return this._roles;
    }

    set roles(value: string[]) {
        this._roles = value;
    }

    get email() {
        return this._email;
    }

    set email(value) {
        this._email = value;
    }

    get recibeMensajes(): boolean {
        return this._recibeMensajes;
    }

    set recibeMensajes(value: boolean) {
        this._recibeMensajes = value;
    }
}
